/**
 * Шапка: мобильное меню и подменю.
 *   .js-header            — шапка; is-opened — панель меню раскрыта
 *   .js-header-toggle     — бургер (aria-expanded)
 *   .js-header-sub        — пункт с подменю; .js-header-sub-toggle раскрывает
 *                           его (is-opened на пункте) — на мобилке аккордеоном,
 *                           на десктопе по клику (ховер — CSS); клик вне и Esc
 *                           закрывают.
 * При открытом меню прокрутка страницы заперта (overflow на html).
 */
itsoftApp.createModule("mobMenu", ["windowResize"], function () {
    const module = this;

    const header = document.querySelector(".js-header");

    if (!header) {
        return false;
    }

    const OPENED = "is-opened";
    const toggle = header.querySelector(".js-header-toggle");
    const subs = header.querySelectorAll(".js-header-sub");
    // Ниже десктопа подменю раскрывается аккордеоном: высота анимируется от
    // текущей к целевой (CSS держит height: 0 + overflow: hidden), по окончании
    // — auto. На десктопе панель выпадающая, высоту не трогаем
    const mobile = window.matchMedia("(max-width: 1023px)");

    // Слайдер баннеров в меню (два и больше баннеров — .js-menu-banner-slider):
    // Swiper грузится лениво при первом открытии меню, не на загрузке страницы
    // (заказчик, 23.10.2026). Без слайдера в разметке ничего не грузится
    let bannerSlider = null;

    const initBannerSlider = function () {
        const el = header.querySelector(".js-menu-banner-slider");
        const library = itsoftApp.modules.slidersLibrary;
        const settings = itsoftApp.modules.slidersSettings;

        if (!el || bannerSlider || !library || !library.callback || !settings || !settings.getSettings) {
            return;
        }

        bannerSlider = new library.callback(el, settings.getSettings(el.getAttribute("data-slider-settings")));
    };

    const setMenu = function (opened) {
        header.classList.toggle(OPENED, opened);
        toggle.setAttribute("aria-expanded", opened ? "true" : "false");
        document.documentElement.style.overflow = opened ? "hidden" : "";

        if (opened) {
            initBannerSlider();
        }
    };

    const slide = function (panel, opened) {
        const from = panel.getBoundingClientRect().height;

        panel.style.transition = "none";
        panel.style.height = from + "px";
        panel.offsetHeight; // eslint-disable-line no-unused-expressions
        panel.style.transition = "";
        panel.style.height = (opened ? panel.scrollHeight : 0) + "px";

        const done = function (evt) {
            if (evt.target !== panel) {
                return;
            }

            panel.removeEventListener("transitionend", done);

            if (panel.closest(".js-header-sub").classList.contains(OPENED)) {
                panel.style.height = "auto";
            }
        };

        panel.addEventListener("transitionend", done);
    };

    const setSub = function (sub, opened) {
        const panel = sub.querySelector(".js-header-sub-panel");

        if (sub.classList.contains(OPENED) === opened) {
            return;
        }

        sub.classList.toggle(OPENED, opened);
        sub.querySelector(".js-header-sub-toggle").setAttribute("aria-expanded", opened ? "true" : "false");

        if (panel && mobile.matches) {
            slide(panel, opened);
        }
    };

    const closeSubs = function (except) {
        Array.prototype.forEach.call(subs, function (sub) {
            if (sub !== except) {
                setSub(sub, false);
            }
        });
    };

    toggle.addEventListener("click", function () {
        setMenu(!header.classList.contains(OPENED));
    });

    Array.prototype.forEach.call(subs, function (sub) {
        const button = sub.querySelector(".js-header-sub-toggle");

        button.addEventListener("click", function () {
            const opened = !sub.classList.contains(OPENED);

            closeSubs(sub);
            setSub(sub, opened);
        });
    });

    document.addEventListener("click", function (evt) {
        if (!evt.target.closest(".js-header-sub")) {
            closeSubs();
        }
    });

    document.addEventListener("keyup", function (evt) {
        if (evt.key === "Escape") {
            closeSubs();
            setMenu(false);
        }
    });

    /* Повернули планшет в ландшафт — панели нет, замок прокрутки снять;
       инлайновые высоты подменю десктопному выпадающему списку не нужны */
    itsoftApp.modules.windowResize.addEvent(function () {
        if (window.innerWidth > 1023) {
            if (header.classList.contains(OPENED)) {
                setMenu(false);
            }

            Array.prototype.forEach.call(header.querySelectorAll(".js-header-sub-panel"), function (panel) {
                panel.style.height = "";
            });
        }
    });

    module.callback = {
        open: function () { setMenu(true); },
        close: function () { setMenu(false); }
    };
});
